import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyD_ZYgTykw3yTsQgpSXfVnllO3SKBkou3U",
  authDomain: "artiza-3cfb3.firebaseapp.com",
  projectId: "artiza-3cfb3",
  messagingSenderId: "813377804764",
  appId: "1:813377804764:web:c640be93dcc1025ee35719",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };

